<ion-header>
  <ion-toolbar>
    <ion-title>Rate Boondocking Site</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="modal-wrapper" #modalWrapper>
    <curbnturf-rating-boondock-start (begin)="navigateForward('start')" *ngIf="beginScreen">
    </curbnturf-rating-boondock-start>
    <curbnturf-rating-boondock-caretaker
      (navigateBack)="navigateBack('caretaker')"
      (becomeCaretaker)="navigateForward('caretaker')"
      (skip)="onSkipSection('caretaker')"
      *ngIf="caretakerScreen"
    >
    </curbnturf-rating-boondock-caretaker>
    <curbnturf-rating-boondock-sections
      (navigateBack)="navigateBack('sections')"
      (reviewSubmitted)="navigateForward('sections')"
      *ngIf="sectionsScreen"
    >
    </curbnturf-rating-boondock-sections>
    <curbnturf-rating-boondock-public-review
      (navigateBack)="navigateBack('review')"
      (savedReview)="navigateForward('review')"
      (completeReview)="onCompleteReview()"
      *ngIf="reviewScreen"
    >
    </curbnturf-rating-boondock-public-review>
    <curbnturf-rating-boondock-activities
      (navigateBack)="navigateBack('activities')"
      (continue)="navigateForward('activities')"
      (skip)="onSkipSection('activities')"
      *ngIf="activitiesScreen"
    >
    </curbnturf-rating-boondock-activities>
    <curbnturf-rating-boondock-amenities
      (navigateBack)="navigateBack('amenities')"
      (continue)="navigateForward('amenities')"
      (skip)="onSkipSection('amenities')"
      *ngIf="amenitiesScreen"
    >
    </curbnturf-rating-boondock-amenities>
    <curbnturf-rating-boondock-terrain
      (navigateBack)="navigateBack('terrain')"
      (continue)="navigateForward('terrain')"
      (skip)="onSkipSection('terrain')"
      *ngIf="terrainScreen"
    >
    </curbnturf-rating-boondock-terrain>
    <curbnturf-rating-boondock-conditions
      (navigateBack)="navigateBack('conditions')"
      (continue)="navigateForward('conditions')"
      (skip)="onSkipSection('conditions')"
      *ngIf="conditionsScreen"
    >
    </curbnturf-rating-boondock-conditions>
    <curbnturf-rating-boondock-description
      (navigateBack)="navigateBack('description')"
      (continue)="navigateForward('description')"
      (skip)="onSkipSection('description')"
      *ngIf="descriptionScreen"
    >
    </curbnturf-rating-boondock-description>
    <curbnturf-rating-boondock-complete
      (navigateBack)="navigateBack('complete')"
      (complete)="navigateForward('complete')"
      *ngIf="completeScreen"
    >
    </curbnturf-rating-boondock-complete>
  </div>
</ion-content>
